import { LeadRawValue } from "src/app/core/models/lead/lead-raw-value.model"

interface IAuditLookup {
    key: string,
    value: string
}

export function jsonToLeadRawValue(source: JSON): LeadRawValue[] | null {
    if (!source) return null
    let rawValues: IAuditLookup[] = (source as any)?.rawValues as IAuditLookup[];

    if (!rawValues) return [];

    return rawValues.map(rv => {
        return {
            id: 0,
            description: rv.key,
            value: rv.value,
            created: new Date(),
            updated: new Date()
        } as LeadRawValue
    });
}

